<div class="form-group">
  <div class="flex-row"></div>
  <span class="form-control span-control" [ngClass]="{'grey-text': !value}">
    <span>{{ value | cropNumber : account?.decimals }}</span>
  </span>
</div>
